module.exports = __webpack_public_path__ + "static/media/24UHCHR20.8c55562c.jpg";